import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { SubscriptionBadgeType } from '../../models/serializable/subscription-badge-type.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class SubscriptionBadgeComponent extends Component {
  static readonly TYPE_ID: string = '5ead95b8701b40d0a33627915e780a5e';

  constructor(
    public readonly badge: SubscriptionBadgeType,
  ) {
    super();
  }

  get $typeId(): string {
    return SubscriptionBadgeComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): SubscriptionBadgeComponent {
    return new SubscriptionBadgeComponent(
        toEnumFromString(MapUtils.get<string>(map, 'badge'), SubscriptionBadgeType)
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'badge': fromEnumAsString(this.badge),
    };
  }

  clone(): this {
    return new SubscriptionBadgeComponent(
        this.badge,
    ) as this;
  }

  isSame(other: SubscriptionBadgeComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.badge === this.badge;
  }
}

export class SubscriptionBadgeComponentBuilder extends DataModelBuilder<SubscriptionBadgeComponent> {
  build(context: SerializationContext, map: SerializedData): SubscriptionBadgeComponent {
    return SubscriptionBadgeComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    this.migrateEnum(map, 'badge', SubscriptionBadgeType, SubscriptionBadgeType.Free);
    return map;
  }
}
